import { css, styled } from '@mui/material/styles'
import { componentSizes } from '@theme/variables'

export const StyledCommonLayout = styled('div')`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  background-size: 1913px 1728px;
  background-repeat: no-repeat;

  ${(props: { fixedViewport: boolean; backgroundImage: string }) =>
    props.fixedViewport
      ? css`
          position: fixed;
          overflow: hidden;
          height: 100%;
          background-image: url('${props.backgroundImage}');
        `
      : css`
          background-image: url('${props.backgroundImage}');
        `}
`

export const StyledCommonLayoutMainWrapper = styled('div')`
  display: flex;
  flex: 1 0;
  ${(props: { fixedViewport: boolean }) =>
    props.fixedViewport
      ? css`
          height: 100%;
          overflow: hidden;
        `
      : ''}
`

export const StyledCommonLayoutMainContent = styled('div')`
  display: flex;
  width: calc(100% - ${componentSizes.leftNavWidth});
  padding-bottom: 16px;
  padding-right: 16px;
`
